import { CoreDataStore } from "./CoreDataStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { handleStoreState } from "../RESTStore/CoreStore";
import { API } from "General/API";
import merge from "deepmerge";

export abstract class ObjectDataStore<T extends object> extends CoreDataStore {
  data: T = {} as T;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      clear: action,
      update: action.bound,
      fetch: action.bound,
    });
  }

  clear() {
    this.data = {} as T;
  }

  @handleStoreState()
  async fetch(queryParams: object = {}, id?: number | string) {
    try {
      const response: T = await API.getData(this.url(id), queryParams);
      runInAction(() => {
        this.data = { ...this.processResponse(response) };
      });
    } catch (error) {
      this.processError(error);
      throw error;
    }
  }

  find() {
    return;
  }

  delete(): Promise<void> {
    return Promise.resolve();
  }

  edit(): Promise<void> {
    return Promise.resolve();
  }

  update(newData: T) {
    this.data = merge(JSON.parse(JSON.stringify(this.data)), JSON.parse(JSON.stringify(newData)), {
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
}
